import React, { useReducer } from "react";

export const AppContext = React.createContext();
export const CLOSE_TOAST = "close_toast";
export const SET_ACTIVE_PERSON = "set_active_person";
export const TOAST = "open_toast";
export const TOGGLE_MENU = "toggle_menu";

const initialState = {
  menuOpen: false,
  sideOpen: window.innerWidth < 577 ? false : true,
  toastOpen: false,
  toastText: "",
  toastVariant: "",
  activePerson: {}
};

const reducer = (state, action) => {
  switch (action.type) {
    case CLOSE_TOAST:
      return { ...state, toastOpen: false, toastText: "", toastVariant: "" };
    case SET_ACTIVE_PERSON:
      return { ...state, activePerson: action.payload };
    case TOAST:
      return {
        ...state,
        toastOpen: true,
        toastText: action.payload.text,
        toastVariant: action.payload.variant
      };
    case TOGGLE_MENU:
      return { ...state, menuOpen: !state.menuOpen };

    default:
      throw new Error(`Wrong action.type: ${action.type}`);
  }
};

const ContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <AppContext.Provider
      value={{
        ctx: state,
        dispatch
      }}
    >
      {props.children}
    </AppContext.Provider>
  );
};

export default ContextProvider;
